import { render, staticRenderFns } from "./DialogsWrapper.vue?vue&type=template&id=71e79192&"
import script from "./DialogsWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports